import { render, staticRenderFns } from "./ScrollButton.vue?vue&type=template&id=53351b27&scoped=true&"
import script from "./ScrollButton.vue?vue&type=script&lang=js&"
export * from "./ScrollButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollButton.vue?vue&type=style&index=0&id=53351b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53351b27",
  null
  
)

export default component.exports